import React, { createContext } from 'react';
import useRoom from './useRoom';
import useLocalTracks from './useLocalTracks';
import useParticipantAppInfo from './useParticipantAppInfo';
import AttachVisibilityHandler from './AttachVisibilityHandler';
import generateConnectionOptions from '../../utils/generateConnectionOptions';
import { useState } from 'react';
import { WarningRed, MainGreen } from '../../utils/colors';
export var VideoContext = createContext(null);
var DEFAULT_THEME_OPTIONS = {
  ctrlButtonColor: WarningRed,
  ctrlBarRadius: '32px',
  statusMessageRadius: '20px',
  statusMessageBGColor: MainGreen
};
export default function VideoProvider(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$allowScreenShare = _ref.allowScreenShare,
      allowScreenShare = _ref$allowScreenShare === void 0 ? false : _ref$allowScreenShare,
      onError = _ref.onError,
      onSpeakerEvent = _ref.onSpeakerEvent,
      _ref$onControlEvent = _ref.onControlEvent,
      onControlEvent = _ref$onControlEvent === void 0 ? function (event, data) {} : _ref$onControlEvent,
      _ref$themeOptions = _ref.themeOptions,
      themeOptions = _ref$themeOptions === void 0 ? DEFAULT_THEME_OPTIONS : _ref$themeOptions,
      _ref$gainCorrection = _ref.gainCorrection,
      gainCorrection = _ref$gainCorrection === void 0 ? 0 : _ref$gainCorrection,
      children = _ref.children;

  var _useState = useState('default'),
      audioSinkDeviceId = _useState[0],
      setAudioSinkDeviceId = _useState[1];

  var onErrorHandler = function onErrorHandler(error) {
    onError && onError(error);
  };

  var _useLocalTracks = useLocalTracks(),
      localTracks = _useLocalTracks.localTracks,
      getLocalVideoTrack = _useLocalTracks.getLocalVideoTrack,
      getLocalTracks = _useLocalTracks.getLocalTracks,
      isAcquiringLocalTracks = _useLocalTracks.isAcquiringLocalTracks,
      removeLocalVideoTrack = _useLocalTracks.removeLocalVideoTrack,
      replaceAudioInputDevice = _useLocalTracks.replaceAudioInputDevice,
      replaceVideoInputDevice = _useLocalTracks.replaceVideoInputDevice,
      addProcessorToVideoTrack = _useLocalTracks.addProcessorToVideoTrack,
      deleteProcessorFromVideoTrack = _useLocalTracks.deleteProcessorFromVideoTrack;

  var _useRoom = useRoom(localTracks, generateConnectionOptions(options)),
      room = _useRoom.room,
      isConnecting = _useRoom.isConnecting,
      connect = _useRoom.connect,
      disconnect = _useRoom.disconnect,
      republishTracks = _useRoom.republishTracks;

  var _useParticipantAppInf = useParticipantAppInfo(),
      participantsInfo = _useParticipantAppInf.participantsInfo,
      setParticipantsInfo = _useParticipantAppInf.setParticipantsInfo;

  return /*#__PURE__*/React.createElement(VideoContext.Provider, {
    value: {
      room: room,
      connect: connect,
      disconnect: disconnect,
      republishTracks: republishTracks,
      isConnecting: isConnecting,
      localTracks: localTracks,
      getLocalVideoTrack: getLocalVideoTrack,
      getLocalTracks: getLocalTracks,
      replaceAudioInputDevice: replaceAudioInputDevice,
      replaceVideoInputDevice: replaceVideoInputDevice,
      isAcquiringLocalTracks: isAcquiringLocalTracks,
      removeLocalVideoTrack: removeLocalVideoTrack,
      audioSinkDeviceId: audioSinkDeviceId,
      replaceAudioOutputDevice: setAudioSinkDeviceId,
      onError: onErrorHandler,
      onSpeakerEvent: onSpeakerEvent,
      onControlEvent: onControlEvent,
      allowScreenShare: allowScreenShare,
      gainCorrection: gainCorrection,
      participantsInfo: participantsInfo,
      setParticipantsInfo: setParticipantsInfo,
      themeOptions: {
        userDefined: Object.assign(DEFAULT_THEME_OPTIONS, themeOptions)
      },
      addProcessorToVideoTrack: addProcessorToVideoTrack,
      deleteProcessorFromVideoTrack: deleteProcessorFromVideoTrack
    }
  }, children, /*#__PURE__*/React.createElement(AttachVisibilityHandler, null));
}